<div class="container-fluid">
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
        <div class="page-title-box">
            <div class="page-title-right">
              <a style="cursor: pointer;" class="btn btn-primary" (click)="volver()">
                  Volver
              </a>
            </div>
            <h3 class="page-title">{{nombre}}</h3>
        </div>
    </div>
  </div>
  <!-- end page title alt- 248 -->
  <hr class="text-dark">

  <div class="row justify-content-center mt-5">

    <div class="col-12 mb-5">
      <form [formGroup]="formulario" id="formulario">
        <div class="row">
          <div class="col-md-6">
            <label for="dismi" class="form-label">Disminutivo</label>
            <input type="text" class="form-control" formControlName="nombre" id="nombre" placeholder="Disminutivo">
          </div>
          <div class="col-md-6">
            <label for="nomb" class="form-label">Nombre</label>
            <input type="text" class="form-control" formControlName="nombre_detalle" id="nombre_detalle" placeholder="Nombre">
          </div>
          <div class="col-12 mt-3">
            <label for="descr" class="form-label">Descripción</label>
            <input type="text" class="form-control" formControlName="descripcion" id="descripcion" placeholder="Descripción">
          </div>
        </div>
      </form>
    </div>

    <hr class="text-dark">

    <div class="col-12 mt-4 text-primary text-center">
      <h3>Seleccione Permisos</h3>
    </div>

    <div class="col-7 mt-3">
      <div class="accordion" id="desplegaMenu">
        <ng-container *ngFor="let menu of menuList; let x = index">
          <div class="row" *ngIf='menu.menu_padre === ""'>
            <div class="col-11">
              <div class="accordion-item">
                <h2 class="accordion-header" id="desplegue{{x}}">
                  <button class="accordion-button text-light btn btn-primary collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          attr.data-bs-target="#panel{{x}}"
                          aria-expanded="false"
                          attr.aria-controls="panel{{x}}">
                    {{menu.menu}}
                  </button>
                </h2>
                <div id="panel{{x}}" class="accordion-collapse collapse" attr.aria-labelledby="desplegue{{x}}">
                  <div class="accordion" id="desplegaMenu2">
                    <ng-container *ngFor="let menuHijo of menuList; let y = index">
                      <div class="accordion-body" *ngIf='menuHijo.menu_padre === menu.id_menu.toString()'>
                        <div class="row">
                          <div class="col-11">
                            <div class="accordion-item">
                              <h2 class="accordion-header" id="desplegue_hijo{{y}}">
                                <button class="accordion-button text-dark collapsed"
                                        style="border-color: #232327 !important;"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        attr.data-bs-target="#panel_hijo{{y}}"
                                        aria-expanded="false" attr.aria-controls="panel_hijo{{y}}">
                                  {{menuHijo.menu}}
                                </button>
                              </h2>
                              <div id="panel_hijo{{y}}" class="accordion-collapse collapse" attr.aria-labelledby="desplegue_hijo{{y}}">
                                <ng-container *ngFor="let menuNieto of menuList; let y = index">
                                  <div class="accordion-body" *ngIf='menuNieto.menu_padre === menuHijo.id_menu.toString()'>
                                    <div class="row">
                                      <div class="col-11"><label>{{menuNieto.menu}}</label></div>
                                      <div class="col-1">
                                        <h4>
                                          <input class="form-check-input"
                                                 style="border: var(--bs-border-width) solid var(--bs-dark);"
                                                 (click)="checkNieto(menuNieto.id_menu.toString(), menuNieto.menu_padre.toString(), menu.id_menu.toString())"
                                                 type="checkbox"
                                                 value="{{menuNieto.id_menu.toString()}}"
                                                 id="{{menuNieto.id_menu.toString()}}">
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                </ng-container>
                              </div>
                            </div>
                          </div>
                          <div class="col-1">
                            <h4>
                              <input class="form-check-input"
                                     style="border: var(--bs-border-width) solid var(--bs-dark);"
                                     (click)="checkHijo(menuHijo.id_menu.toString(), menuHijo.menu_padre)"
                                     type="checkbox"
                                     value="{{menuHijo.id_menu.toString()}}"
                                     id="{{menuHijo.id_menu.toString()}}">
                            </h4>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-1">
              <h4 style="margin-top: 8px;">
                <input class="form-check-input"
                       style="border: var(--bs-border-width) solid var(--bs-dark);"
                       (click)="checkPadre(menu.id_menu.toString())"
                       type="checkbox"
                       value="{{menu.id_menu}}"
                       id="{{menu.id_menu}}">
              </h4>
            </div>
          </div>
        </ng-container>
        <div class="row mt-3">
          <div class="col-md-12 text-center">
            <a style="cursor: pointer;" class="btn btn-lg btn-primary" (click)="cargar()">Aceptar</a>
          </div>
        </div>
      </div>
    </div>





  </div>
</div>



<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje"></app-modal>
